export default __webpack_public_path__ + "static/media/Guitars_01.93bbdba3.png";